<template>
  <div class="filter">
    <div class="label-title mb-3">
      {{ $t('view-Search.filter-title.channel-age') }}
    </div>
    <div>
      <range-input
        v-model="channelAge"
        :min="0"
        :max="maxAge"
        :marks="channelAgeMarks"
        :contained="true"
        tooltip="always"
        :dot-size="16"
      />
    </div>
  </div>
</template>

<script>
import '../../../assets/scss/vue-slider.scss'
import VueSlider from 'vue-slider-component'

export default {
  components: {
    'range-input': VueSlider
  },
  props: {
    value: {
      type: Array,
      default: null
    }
  },
  computed: {
    channelAge: {
      get () {
        return [parseInt(this.value[0]) || 0, parseInt(this.value[1]) || this.maxAge]
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    channelAgeMarks () {
      const markers = { 0: '0' }
      markers[this.maxAge] = `${this.maxAge}  ${this.$t('view-Search.years')}`
      return markers
    },
    maxAge () {
      const max = this.$store.state.search.filtersData.theOldestAgeOfChannels
      return max && max > 1 ? max : 1
    }
  },
  created () {
    if (this.maxAge === 1) {
      this.$store.dispatch('search/getFiltersData').catch(e => {})
    }
  }
}
</script>
